/*
Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.
*/
export const environment = {
    production: false,
    apiUrl: 'https://dev-portal.bagradar.sita.aero',
  };
  